export const multipletextitemConfig = [
  {
    name: 'sentiment',
    type: 'sentiment',
    category: 'general',
    isRequired: false,
  },
];
